import useMinWidth from '@/hooks/useMinWidth'

export function useIsMinWidthXl() {
  return useMinWidth('xl')
}
